interface FilterOption {
  label: string;
  value: string;
}

interface FilterSelectProps {
  label?: string;
  placeholder?: string;
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
  showAllOption?: boolean;
}

export default function FilterSelect({
  label,
  placeholder,
  options,
  value,
  onChange,
  showAllOption = true,
}: FilterSelectProps) {
  const displayPlaceholder = placeholder || (label ? `Filter berdasarkan ${label}` : 'Pilih opsi');
  const selectOptions = showAllOption && label ? [{ label: `Semua ${label}`, value: '' }, ...options] : options;

  return (
    <select
      value={value}
      onChange={e => onChange(e.target.value)}
      className="w-full md:w-fit h-[38px] px-3 py-1.5 text-sm bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none pr-8"
      style={{
        backgroundImage:
          "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%236b7280'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E\")",
        backgroundPosition: 'right 0.5rem center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '1.2em 1.2em',
      }}
    >
      {!selectOptions.find(opt => opt.value === '') && (
        <option value="" disabled hidden>
          {displayPlaceholder}
        </option>
      )}
      {selectOptions.map(opt => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
